module.exports = __webpack_public_path__ + "img/abdomen.585c98cc.svg";